var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.223,
    height: 20.48,
    viewBox: "0 0 29.223 20.48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}.b{fill:#020202;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.118 2)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 14.765,
    height: 14.765,
    transform: "translate(-0.431 -1.048)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1.118 -2)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 19.528,
    height: 19.528,
    transform: "translate(0 0.953)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1.429,17.147a1.429,1.429,0,0,1,0-2.858H12.854a1.429,1.429,0,0,1,0,2.858Zm0-7.145a1.429,1.429,0,1,1,0-2.858H22.137a1.429,1.429,0,0,1,0,2.858Zm0-7.144A1.429,1.429,0,1,1,1.429,0H27.137a1.429,1.429,0,1,1,0,2.858Z",
    transform: "translate(0.657)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/Menu.1f452133703cc527b477a875c39a4e23.svg";
export { ForwardRef as ReactComponent };